<template lang="pug">
    .steps
      template(v-for="step in steps")
        component.step(
          :is="getComponent(step)"
          v-bind="getProperties(step)"
          :class="{ done: step.position < position, active: step.position === position }"
          @click.prevent="navigateTo(step)"
        )
          .point
            font-awesome-icon(v-if="step.icon" :icon="step.icon")
          .label {{ step.label }}
        .way(v-if="step.position < steps.length" :class="{ done: step.position < position }")
</template>

<script>
export default {
  name: 'Tabs',
  props: {
    steps: {
      type: Array,
      required: true
    },
    position: {
      type: Number,
      default: 0
    },
    disableNextSteps: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    getComponent(step) {
      let component = 'div';

      const previousStep = this.steps.find(el => el.position === step.position - 1);
      if (component !== 'a' && this.position > step.position) component = 'a';
      if (component !== 'a' && this.position !== step.position && step.valid) component = 'a';
      if (component !== 'a' && this.position !== step.position && previousStep && previousStep.valid) component = 'a';

      if (step.position > this.position && this.disableNextSteps) component = 'div';

      return component;
    },
    getProperties(step) {
      const component = this.getComponent(step);

      let properties = {};
      if (component === 'a') {
        properties.href = '';
      }

      return properties;
    },
    navigateTo(step) {
      const component = this.getComponent(step);

      if (component === 'a') {
        this.$emit('navigate-to', step);
      }
    }
  }
};
</script>

<style lang="sass">
.steps
  @apply flex items-center
  @apply mt-6 mb-10 px-3
  @screen md
    @apply p-8 mb-10 mx-4
  .step
    @apply flex items-center text-gray-500 relative
    &.active
      @apply text-white
      .point
        // @apply bg-blue-600 border-blue-600
        background: var(--color-primary)
        border-color: var(--color-primary)
        // --switch:calc((var(--primary-color-l) - var(--contrastThreshold)) * -100)
        // color: hsl(0, 0%, var(--switch))
      .label
        // @apply text-blue-600
        color: var(--color-primary)
        display: block
    &.done
      // @apply text-blue-600
      color: var(--color-primary)
      .point
        // @apply border-blue-600
        border-color: var(--color-primary)
      .label
        // @apply text-blue-600
        color: var(--color-primary)
    .point
      @apply flex items-center justify-center text-lg rounded-full transition duration-150 ease-in-out h-12 w-12 py-3 border-2 border-gray-300
    .label
      @apply absolute top-0 -ml-10 text-center mt-16 w-32 text-xs font-medium uppercase text-gray-500
      display: none
      pointer-events: none
      @screen md
        display: block
  a.step
    // @apply text-blue-600
    color: var(--color-primary)
    .point
      // @apply border-blue-600
      border-color: var(--color-primary)
    .label
      // @apply text-blue-600
      color: var(--color-primary)
    &:hover,
    &:focus
      @apply text-white
      .point
        // @apply bg-blue-600 border-blue-600
        background: var(--color-primary)
        border-color: var(--color-primary)
        // --switch:calc((var(--primary-color-l) - var(--contrastThreshold)) * -100)
        // color: hsl(0, 0%, var(--switch))
      .label
        // @apply text-blue-600
        color: var(--color-primary)
        display: block
  .way
    @apply flex-auto border-t-2 transition duration-150 ease-in-out border-gray-300
    &.done
      // @apply border-blue-600
      border-color: var(--color-primary)
</style>
